import script from "./shezhifeitongyi.vue?vue&type=script&setup=true&lang=js"
export * from "./shezhifeitongyi.vue?vue&type=script&setup=true&lang=js"

import "./shezhifeitongyi.vue?vue&type=style&index=0&id=925d8208&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-925d8208"]])

export default __exports__